export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-color/src/math.js
// module id = 134
// module chunks = 0 1 2